import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedModule } from 'src/app/shared/shared.module';
import { SlickCarouselUtilService } from '../../../utility/slick-carousel.util';
import { PromotionalTextModule } from '../promotional-text/promotional-text.module';
import { TooltipIconModule } from '../tooltip-icon/tooltip-icon.module';
import { HighlightedProductComponent } from './highlighted-product.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    MediaModule,
    I18nModule,
    SlickCarouselModule,
    PromotionalTextModule,
    SharedModule,
    TooltipIconModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoHighlightedProductsComponent: {
          component: HighlightedProductComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    HighlightedProductComponent,
  ],
  providers: [SlickCarouselUtilService],
})
export class HighlightedProductModule {}
